import { Location } from 'react-router-dom';

export const getRouteSteps = (location: Location) =>
  location.pathname?.split('/').filter((_) => !!_);
